export default {
  state: () => {
    return {
      aliveComponents: [] // 存活的组件名
    }
  },
  mutations: {
    setAliveComponents(state, data) {
      if (data.type === 'add') {
        state.aliveComponents.push(data.name)
      }
      if (data.type === 'delete') {
        let index = state.aliveComponents.indexOf(data.name)
        if (index > -1) {
          state.aliveComponents.splice(index, 1)
        }
      }
    },
    emptyAliveComponents(state, data) {
      state.aliveComponents = []
    }
  }
}